/**
 * `localStorage`, but never fatal — private browsing mode and a full quota
 * both throw on `getItem`/`setItem`, and neither should take a feature down
 * over what's usually just a persisted display preference.
 *
 * Callers own key naming and value parsing (booleans as `'true'`/`'false'`
 * strings, string-enum unions, etc.) — this only wraps the storage access
 * itself, the part every caller was independently re-wrapping in the same
 * try/catch.
 */

export function readStoredValue(key: string): string | null {
  try {
    return globalThis.localStorage?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

export function writeStoredValue(key: string, value: string): void {
  try {
    globalThis.localStorage?.setItem(key, value);
  } catch {
    // Private browsing or a full quota. The value still works for this
    // session; it just won't be remembered.
  }
}
